import { getEditorState } from '~/shell/Store';
import {
  DragAndDropZoneDefinition,
  DRAG_AND_DROP_ZONE,
  DRAG_ZONE,
  DropZoneDefinition,
  DROP_ZONE,
  LAYOUT_COLUMNS,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const Quiz5: Translator = sequence => {
  const editorMode = getEditorState().editorMode;
  return translate(sequence, item => {
    if (item.__typename === 'Question') {
      return {
        type: DRAG_AND_DROP_ZONE,
        id: 'DRAG_AND_DROP_ZONE',
        items: [
          {
            type: LAYOUT_COLUMNS,
            id: `${item.id}-columns`,
            items: [
              {
                type: DRAG_ZONE,
                id: sequence.id,
                items: [
                  {
                    type: TEXT,
                    id: `${item.id}_subtitle`,
                    items: [],
                    values: {
                      value: item.subtitle,
                      variant: 'sub_heading',
                      icon: item?.icon || ''
                    }
                  },
                  {
                    type: TEXT,
                    id: item.id + '_title',
                    items: [],
                    values: {
                      value: item.title,
                      variant: 'heading1',
                      lineHeight: '32px'
                    }
                  },
                  ...(item.body && item.body.trim() !== ''
                    ? [
                        {
                          type: TEXT,
                          id: item.id + '_body',
                          items: [],
                          values: {
                            value: item.body,
                            variant: 'text'
                          }
                        }
                      ]
                    : [])
                ],
                values: {
                  items: item.items,
                  question: item.title || ''
                }
              },
              {
                type: DROP_ZONE,
                id: 'drag_zone',
                items: [],
                values: {
                  helpMessage: item.body,
                  items: item.items
                }
              } as DropZoneDefinition
            ]
          }
        ],
        values: {}
      } as DragAndDropZoneDefinition;
    }
    return null;
  });
};
